import React, { createContext, useState } from 'react';

interface AuthContextProps {
  token: string | null;
  username: string | null;
  setToken: (token: string | null) => void;
  setUsername: (username: string | null) => void;
}

export const AuthContext = createContext<AuthContextProps>({
  token: null,
  username: null,
  setToken: () => {},
  setUsername: () => {},
});

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [token, setTokenState] = useState<string | null>(
    localStorage.getItem('token')
  );
  const [username, setUsername] = useState<string | null>(null);

  // ← setToken ahora actualiza contexto Y localStorage a la vez
  const setToken = (newToken: string | null) => {
    if (newToken) {
      localStorage.setItem('token', newToken);
    } else {
      localStorage.removeItem('token');
    }
    setTokenState(newToken);
  };

  return (
    <AuthContext.Provider value={{ token, username, setToken, setUsername }}>
      {children}
    </AuthContext.Provider>
  );
};
